import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PopoverController} from '@ionic/angular';
import {DateRange} from '../../../services/common-datatypes';
import {AutoUnsubscribe, RequiredInput} from '../../../decorators/common.decorators';
import {DateInputPopoverComponent, StartEndDate} from './date-input-popover.component';
import {StateStorageService} from '../../../services/state-storage.service';
import {skip} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {formatDate} from "@angular/common";
import * as dayjs from "dayjs";
import * as customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

// note all dates are converted from utc to local time in rest layer

@Component({
    selector: 'app-date-input',
    templateUrl: './date-input.component.html',
    styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent implements OnInit, OnDestroy {

    public fullDate: string = '';
    @Input() inline = false;
    @Input() autoOpen = false;
    @Input() singleDate = true;
    @Input() @RequiredInput translationPrefix = '';
    @Input() date: DateRange = new DateRange();
    @Input() minDate: string = '';
    @Input() maxDate: string = '';
    @Input() disabledDays: Date[] = [];
    @Input() localeOptions = {}
    @Output() dateChange = new EventEmitter<DateRange>();

    // noinspection JSMismatchedCollectionQueryUpdate
    @AutoUnsubscribe('ngOnDestroy')
    private subscriptions: Subscription[] = [];

    constructor(private popoverCtrl: PopoverController,
                private appState: StateStorageService) {
    }

    ngOnInit() {
        this.setFullDate();
        if (this.autoOpen) this.openDropDown();
    }

    ngOnDestroy(): void {
    }

    private setFullDate(): void {
        let tempDate = '';
        if (this.date.from) {
            tempDate += formatDate(this.date.from, 'fullDate', this.appState.locale);
        }
        if (!this.singleDate) {
            tempDate += ' - ';
            if ((this.date.from !== this.date.to) && this.date.to) {
                tempDate += formatDate(this.date.to, 'fullDate', this.appState.locale);
            }
        }
        this.fullDate = tempDate;
    }

    clearDate(event: Event) {
        if (event) event.stopPropagation();
        this.date.from = '';
        this.date.to = '';
        this.setFullDate();
        this.dateChange.emit(this.date);
    }

    dateChanged(range: StartEndDate) {
        if (range.start) {
            this.date.from = range.start.format();
        } else {
            this.date.from = '';
        }
        if (this.singleDate || !range.end) {
            this.date.to = '';
        } else {
            this.date.to = range.end.format();
        }
//        console.log('dateChanged: ', this.date);
        this.dateChange.emit(this.date);
    }

    openDropDown(event: Event | undefined = undefined) {

        this.popoverCtrl.create({
                component: DateInputPopoverComponent,
                componentProps: {
                    startDate: this.date.from,
                    endDate: this.date.to,
                    minDate: this.minDate,
                    // dateChange: this.dateChanged,   <-- not working
                    maxDate: this.maxDate,
                    invalidDays: this.disabledDays,
                    // locale: this.localeOptions,
                    singleDatePicker: this.singleDate
                },
                animated: false,
                event: event,
                cssClass: 'date-popover',
            }
        ).then((popover: HTMLIonPopoverElement) => {
            popover.present();
            popover.onDidDismiss().then((resultEvent: { data?: StartEndDate | null, role?: string }) => {
                if ('ok' === resultEvent.role && resultEvent.data) {
                    this.dateChanged(resultEvent.data);
                }
                this.setFullDate();
            });
            this.subscriptions.push(this.appState.navigation$.pipe(skip(1))
                .subscribe(() => {
                    popover.dismiss();
                })
            );
        });
    }

}
